"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MaterialIcon = _interopRequireDefault(require("../MaterialIcon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _styled = require("./styled");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const OptionGroup = _ref => {
  let {
    activeColor,
    backgroundColor,
    bordered = true,
    direction = 'row',
    disabled = false,
    error,
    fontSize = '14px',
    height = '40px',
    margin = '0px',
    options = [],
    padding = "0px 10px 0px 0px",
    size = 20,
    onChange = () => null,
    textColor,
    value,
    width = 'auto'
  } = _ref;
  const {
    disabledColor,
    primaryColor
  } = (0, _styledComponents.useTheme)();
  const [selected, setSelected] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    setSelected(value);
  }, [value]);
  const handleClick = (e, value) => {
    e.preventDefault();
    if (disabled) {
      return;
    }
    setSelected(value);
    onChange(value);
  };
  const containerProps = {
    backgroundColor,
    margin,
    width
  };
  const optionContainerProps = {
    bordered,
    direction,
    height,
    padding
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.OptionContainer, _objectSpread(_objectSpread({}, optionContainerProps), {}, {
      children: options.map((_ref2, index) => {
        let {
          label,
          value: optionValue
        } = _ref2;
        const checked = selected === optionValue;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Option, {
          activeColor: activeColor,
          disabled: disabled,
          fontSize: fontSize,
          onClick: e => handleClick(e, optionValue),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, {
            color: checked && !disabled ? activeColor !== null && activeColor !== void 0 ? activeColor : primaryColor : disabledColor,
            icon: checked ? 'radio_button_checked' : 'radio_button_unchecked',
            inactive: disabled,
            size: size
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.OptionText, {
            color: textColor,
            disabled: disabled,
            children: label
          })]
        }, index);
      })
    })), !!error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.ErrorMessage, {
      fontSize: fontSize,
      children: error
    })]
  }));
};
OptionGroup.propTypes = {
  activeColor: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  bordered: _propTypes.default.bool,
  direction: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.string,
  fontSize: _propTypes.default.string,
  height: _propTypes.default.string,
  margin: _propTypes.default.string,
  onChange: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  })),
  padding: _propTypes.default.string,
  size: _propTypes.default.number,
  textColor: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.string]),
  width: _propTypes.default.string
};
var _default = exports.default = OptionGroup;